import AppPlateFormLogos from "components/appplateformlogos";
import Footer from "components/global/footer";
import HeroBanner from "components/herobanner";
import Testimonials from "components/testimonials";
import { Helmet } from "react-helmet";

const OrderBadgeIcon = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1192 29.7502L4.25 15.881V18.7144C4.25 19.4652 4.5475 20.1877 5.08583 20.7119L16.1217 31.7477C17.2267 32.8527 19.0258 32.8527 20.1308 31.7477L28.9283 22.9502C30.0333 21.8452 30.0333 20.046 28.9283 18.941L18.1192 29.7502Z"
        fill="#3A7789"
      />
      <path
        d="M16.1217 24.6642C17.2267 25.7692 19.0258 25.7692 20.1308 24.6642L28.9283 15.8667C30.0333 14.7617 30.0333 12.9625 28.9283 11.8575L17.8925 0.821667C17.3544 0.296511 16.6327 0.00176421 15.8808 0L7.08333 0C5.525 0 4.25 1.275 4.25 2.83333V11.6308C4.25 12.3817 4.5475 13.1042 5.08583 13.6283L16.1217 24.6642ZM10.2708 4.25C10.7405 4.25 11.1909 4.43657 11.523 4.76867C11.8551 5.10076 12.0417 5.55118 12.0417 6.02083C12.0417 6.49049 11.8551 6.94091 11.523 7.273C11.1909 7.6051 10.7405 7.79167 10.2708 7.79167C9.80118 7.79167 9.35076 7.6051 9.01866 7.273C8.68657 6.94091 8.5 6.49049 8.5 6.02083C8.5 5.55118 8.68657 5.10076 9.01866 4.76867C9.35076 4.43657 9.80118 4.25 10.2708 4.25Z"
        fill="#3A7789"
      />
    </svg>
  );
};

const HandDropIcon = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.75 0.998047C29.246 1.5143 28.7315 2.02005 28.2415 2.54855C27.3245 3.54611 26.4728 4.6018 25.6917 5.70905C24.3617 7.60605 22.75 10.4043 22.75 13.1255C22.75 14.9821 23.4875 16.7625 24.8003 18.0753C26.113 19.3881 27.8935 20.1255 29.75 20.1255C31.6065 20.1255 33.387 19.3881 34.6997 18.0753C36.0125 16.7625 36.75 14.9821 36.75 13.1255C36.75 10.4043 35.1383 7.60605 33.8083 5.70905C33.0272 4.6018 32.1755 3.54611 31.2585 2.54855C30.7685 2.02005 30.254 1.5143 29.75 0.998047ZM14.7613 23.188C14.4739 23.1873 14.1892 23.2432 13.9235 23.3525C13.6578 23.4618 13.4162 23.6224 13.2125 23.8251L9.625 27.4125V34.1255H19.4722L29.6292 31.5863L35.8085 28.949C35.984 28.8529 36.1255 28.705 36.2137 28.5254C36.3019 28.3458 36.3325 28.1433 36.3013 27.9457C36.27 27.7481 36.1786 27.5649 36.0393 27.4212C35.9 27.2776 35.7198 27.1804 35.5233 27.143C35.3761 27.1173 35.2252 27.1233 35.0805 27.1605L35.0455 27.1693L23.8245 29.7505H17.5V26.2505H22.9688C23.3749 26.2505 23.7643 26.0892 24.0515 25.8021C24.3387 25.5149 24.5 25.1254 24.5 24.7193C24.5 24.3132 24.3387 23.9237 24.0515 23.6365C23.7643 23.3494 23.3749 23.188 22.9688 23.188H14.7613ZM27.9773 25.2041L34.1932 23.7743C35.2634 23.4913 36.4005 23.6151 37.3847 24.1219C38.3689 24.6287 39.1301 25.4824 39.5213 26.5179C39.9125 27.5535 39.9058 28.6973 39.5025 29.7282C39.0992 30.7591 38.328 31.6038 37.338 32.099L37.2907 32.1218L30.7458 34.9148L19.9028 37.6255H0V24.938H7.1505L10.7415 21.347C11.2706 20.8198 11.8984 20.4018 12.589 20.1172C13.2796 19.8325 14.0195 19.6867 14.7665 19.688H22.9688C23.6704 19.688 24.3643 19.8346 25.0059 20.1186C25.6475 20.4026 26.2226 20.8177 26.6943 21.3372C27.1659 21.8566 27.5237 22.469 27.7447 23.1349C27.9656 23.8009 28.0449 24.5057 27.9773 25.2041ZM6.125 28.438H3.5V34.1255H6.125V28.438Z"
        fill="#3A7789"
      />
    </svg>
  );
};

const RestaurantsIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37 8L37.8593 7.42716C39.1556 6.56294 40.8444 6.56294 42.1407 7.42716C42.6776 7.78504 43 8.38753 43 9.03271V18C43 21.3137 40.3137 24 37 24M37 8L36.2188 7.4792C34.8752 6.58347 33.1248 6.58347 31.7812 7.4792L31 8M37 8V18M31 8L30.1407 7.42716C28.8444 6.56294 27.1556 6.56294 25.8593 7.42716C25.3224 7.78504 25 8.38753 25 9.03271V18C25 21.3137 27.6863 24 31 24M31 8V18M37 24H31M37 24L37.9021 36.6297C37.9662 37.5267 37.7878 38.4244 37.3856 39.2288L36.8944 40.2111C36.3463 41.3075 35.2257 42 34 42C32.7743 42 31.6537 41.3075 31.1056 40.2111L30.6144 39.2288C30.2122 38.4244 30.0338 37.5267 30.0979 36.6297L31 24M16 24H10L9.09788 36.6297C9.03381 37.5267 9.21221 38.4244 9.6144 39.2288L10.1056 40.2111C10.6537 41.3075 11.7743 42 13 42C14.2257 42 15.3463 41.3075 15.8944 40.2111L16.3856 39.2288C16.7878 38.4244 16.9662 37.5267 16.9021 36.6297L16 24ZM7.68442 10.168L8.54307 8.62247C9.4423 7.00386 11.1484 6 13 6C14.8516 6 16.5577 7.00386 17.4569 8.62247L18.3156 10.168C20.0059 13.2106 20.1686 16.8705 18.755 20.0511L18.6246 20.3448C17.6367 22.5675 15.4324 24 13 24C10.5676 24 8.36334 22.5675 7.37545 20.3448L7.24495 20.0511C5.83135 16.8705 5.9941 13.2106 7.68442 10.168Z"
        stroke="#3A7789"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const CheafCapIcon = () => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.294 27.7497H7.71066M18.5023 27.7497V18.4997M23.1273 27.7497V21.583M13.8773 27.7497V21.583M29.294 33.9163V17.4668C29.8665 17.2581 30.3921 16.9385 30.8407 16.5262C31.2892 16.1139 31.652 15.617 31.908 15.0641C32.1641 14.5113 32.3084 13.9133 32.3327 13.3045C32.357 12.6957 32.2608 12.0881 32.0497 11.5165C31.8385 10.945 31.5166 10.4208 31.1023 9.97404C30.688 9.52728 30.1895 9.16675 29.6355 8.91315C29.0815 8.65954 28.4829 8.51787 27.874 8.49625C27.2651 8.47463 26.6579 8.5735 26.0873 8.78717C25.5169 5.97209 22.2948 3.08301 18.5023 3.08301C14.7098 3.08301 11.4877 5.97209 10.9173 8.78717C9.76635 8.36194 8.49358 8.41136 7.37903 8.92454C6.26448 9.43773 5.39944 10.3726 4.97421 11.5236C4.54898 12.6746 4.59839 13.9474 5.11157 15.0619C5.62476 16.1765 6.55968 17.0415 7.71066 17.4668V33.9163H29.294Z"
        stroke="#3A7789"
        strokeWidth="3.08333"
      />
    </svg>
  );
};

const BagIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.4839 10.8406C33.0699 7.73561 30.4213 5.41667 27.2888 5.41667H12.7106C9.57807 5.41667 6.92942 7.73561 6.51542 10.8406L4.51541 25.8407C4.01584 29.5874 6.93066 32.9167 10.7106 32.9167H29.2888C33.0687 32.9167 35.9835 29.5874 35.4839 25.8406L33.4839 10.8406ZM24.5833 11.6667C24.5833 10.9763 25.1429 10.4167 25.8333 10.4167C26.5236 10.4167 27.0833 10.9763 27.0833 11.6667C27.0833 15.2921 23.724 17.9167 19.9999 17.9167C16.2758 17.9167 12.9166 15.2921 12.9166 11.6667C12.9166 10.9763 13.4762 10.4167 14.1666 10.4167C14.8569 10.4167 15.4166 10.9763 15.4166 11.6667C15.4166 13.5637 17.2811 15.4167 19.9999 15.4167C22.7187 15.4167 24.5833 13.5637 24.5833 11.6667Z"
        fill="white"
      />
    </svg>
  );
};

const WatchIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9999 3.33331C10.8166 3.33331 3.33325 10.8166 3.33325 20C3.33325 29.1833 10.8166 36.6666 19.9999 36.6666C29.1833 36.6666 36.6666 29.1833 36.6666 20C36.6666 10.8166 29.1833 3.33331 19.9999 3.33331ZM27.2499 25.95C27.0166 26.35 26.5999 26.5666 26.1666 26.5666C25.9499 26.5666 25.7333 26.5166 25.5333 26.3833L20.3666 23.3C19.0833 22.5333 18.1333 20.85 18.1333 19.3666V12.5333C18.1333 11.85 18.6999 11.2833 19.3833 11.2833C20.0666 11.2833 20.6333 11.85 20.6333 12.5333V19.3666C20.6333 19.9666 21.1333 20.85 21.6499 21.15L26.8166 24.2333C27.4166 24.5833 27.6166 25.35 27.2499 25.95Z"
        fill="white"
      />
    </svg>
  );
};

const MobileIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.0667 3.33333H12.9334C8.33342 3.33333 6.66675 4.99999 6.66675 9.68333V30.3167C6.66675 35 8.33342 36.6667 12.9334 36.6667H27.0501C31.6667 36.6667 33.3334 35 33.3334 30.3167V9.68333C33.3334 4.99999 31.6667 3.33333 27.0667 3.33333ZM20.0001 32.1667C18.4001 32.1667 17.0834 30.85 17.0834 29.25C17.0834 27.65 18.4001 26.3333 20.0001 26.3333C21.6001 26.3333 22.9167 27.65 22.9167 29.25C22.9167 30.85 21.6001 32.1667 20.0001 32.1667ZM23.3334 10.4167H16.6667C15.9834 10.4167 15.4167 9.85 15.4167 9.16666C15.4167 8.48333 15.9834 7.91666 16.6667 7.91666H23.3334C24.0167 7.91666 24.5834 8.48333 24.5834 9.16666C24.5834 9.85 24.0167 10.4167 23.3334 10.4167Z"
        fill="white"
      />
    </svg>
  );
};

const FruitIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0125 11.7851C15.7219 11.1422 14.34 10.8938 12.9635 11.1363C8.39235 11.9415 5.61328 17.8544 6.75634 24.343C7.8994 30.8316 12.5317 35.4389 17.1028 34.6336C17.263 34.6054 17.4209 34.5721 17.5766 34.5336C19.1167 34.1527 20.8838 34.1527 22.4239 34.5336C22.5795 34.5721 22.7375 34.6054 22.8976 34.6336C27.4688 35.4389 32.1011 30.8316 33.2441 24.343C34.3872 17.8544 31.6081 11.9415 27.0369 11.1363C25.6604 10.8938 24.2785 11.1422 22.988 11.7851C21.1717 12.6898 18.8288 12.6898 17.0125 11.7851ZM12.196 22.2786C12.3183 22.958 11.8666 23.608 11.1872 23.7302C10.5077 23.8525 9.85783 23.4008 9.73555 22.7214C9.39972 20.8553 9.62874 19.0195 10.3344 17.5498C11.0394 16.0814 12.2766 14.8908 13.9543 14.6015C14.6346 14.4842 15.2812 14.9406 15.3985 15.6209C15.5158 16.3012 15.0594 16.9478 14.3791 17.0652C13.6995 17.1823 13.0415 17.6874 12.5881 18.6319C12.1352 19.575 11.9424 20.8693 12.196 22.2786Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4067 7.91966C17.8966 8.98114 17.9167 10.3599 17.9167 11.6667C17.9167 12.357 18.4763 12.9167 19.1667 12.9167C19.857 12.9167 20.4167 12.357 20.4167 11.6667C20.4167 11.6372 20.4167 11.6073 20.4167 11.577C20.4172 10.3772 20.418 8.47824 19.6766 6.87201C19.2788 6.01013 18.6582 5.20348 17.7091 4.6235C16.7666 4.04752 15.5902 3.75 14.1667 3.75C13.4763 3.75 12.9167 4.30964 12.9167 5C12.9167 5.69036 13.4763 6.25 14.1667 6.25C15.2431 6.25 15.9417 6.47331 16.4055 6.75671C16.8627 7.03611 17.1795 7.42737 17.4067 7.91966Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7522 7.39982C22.3737 7.81579 21.2864 8.9031 20.8704 10.2816C22.2489 9.86562 23.3362 8.77831 23.7522 7.39982ZM25.0001 4.71654C25.7928 4.71654 26.4355 5.3592 26.4355 6.15197ZM26.4355 6.15197C26.4355 9.91463 23.3853 12.9649 19.6226 12.9649C18.8298 12.9649 18.1872 12.3222 18.1872 11.5294C18.1872 7.76678 21.2374 4.71654 25.0001 4.71654"
        fill="white"
      />
    </svg>
  );
};

const wastedFoods = [
  {
    id: 0,
    imageUrl: "/images/food-loss-awareness.jpg",
    title:
      "Over 194 million Indians are undernourished, yet surplus food goes uneaten every day.",
  },
  {
    id: 1,
    imageUrl:
      "/images/green-leaf-symbolizing-co2-absorption-surrounded-by-forest-clouds.jpg",
    title:
      "Food waste generates methane, a greenhouse gas that is 25 times more potent than carbon dioxide, contributing significantly to climate change.",
  },
  {
    id: 2,
    imageUrl: "/images/shop-counter.jpg",
    title: "One-third of the food produced around the world is never consumed",
  },
];

const useSurpeats = [
  {
    index: 0,
    icon: <OrderBadgeIcon />,
    title: "Enjoy good food at ½ price or less",
  },
  {
    index: 1,
    icon: <HandDropIcon />,
    title: "Help the environment by reducing food waste",
  },
  {
    index: 2,
    icon: <RestaurantsIcon />,
    title: "Rescue food near you",
  },
  {
    index: 3,
    icon: <CheafCapIcon />,
    title: "Try something new from local cafes, bakeries or restaurants",
  },
];

const howToUseSteps = [
  {
    id: 0,
    title: "Step 1",
    description:
      "Discover Mystery Bags available at stores and restaurants near you.",
    icon: <BagIcon />,
  },
  {
    id: 1,
    title: "Step 2",
    description:
      "Confirm your choice, reserve your food, and pay through the app.",
    icon: <MobileIcon />,
  },
  {
    id: 2,
    title: "Step 3",
    description:
      "Head to the shop at the specified pickup time and collect the bag.",
    icon: <WatchIcon />,
  },
  {
    id: 3,
    title: "Step 4",
    description: "Enjoy fresh meals while helping reduce food waste",
    icon: <MobileIcon />,
  },
];

const testimonials = [
  {
    id: 0,
    // image: "images/testimonials-1.png",
    name: "— Priya M., Mumbai",
    // idName: "@fredericakoen",
    description: `Surpeats has completely transformed how I think about food. I’ve saved so much
money on meals, and it feels amazing to know I’m helping reduce food waste at the
same time. The mystery bag concept is so exciting—I never know what surprise
awaits me!"`,
  },
  {
    id: 1,
    // image: "images/testimonials-2.png",
    name: "— Karan J., Mumbai",
    // idName: "@johntompoe",
    description: `Surpeats has made eating out so much more affordable and sustainable. I love the
mission of reducing food waste, and it feels good to contribute to that. That said, the
app interface could be smoother. It’s sometimes hard to filter by cuisine or location.
Adding a rating system for mystery bags would also be helpful!`,
  },
  {
    id: 2,
    // image: "images/testimonials-1.png",
    name: "— Anjali T., Mumbai",
    // idName: "@fredericakoen",
    description: `I’m a big fan of Surpeats! The idea of rescuing food and getting it at such low prices
is brilliant. I just wish there were more variety in the mystery bags—sometimes they
feel repetitive, especially from the same restaurant. Adding more restaurant partners
in my area would be amazing!"`,
  },
];

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Home</title>
      </Helmet>
      
      <HeroBanner
        heroBannerImgUrl="images/sandwich-brown-bag-lunches.png"
        showAppLogoInHeader={false}
        title={`Turn surplus food into opportunity. "Big Change Starts with Small Bites."`}
        titleWrapperClassName="max-w-full text-center"
        description="Our app is almost here! Get ready to join us in tackling food waste with just a few taps. Stay tuned for the launch."
      />
      
      <section className="container mb-10 pt-16 lg:mb-44">
        <div className="flex  bg-primary-50 rounded-lg flex-col gap-5 lg:gap-28 lg:flex-row lg:rounded-3xl">
          <div className="max-w-lg w-full px-3 py-7 lg:py-10 lg:pl-7">
            <h2 className="text-2xl text-black mb-3.5 font-anton lg:text-4xl lg:leading-10 lg:pr-10">
              India sees an estimated  78{" "}
              <span className="text-primary-100">million</span> tons of food
              wasted annually
            </h2>
            <p className="text-base leading-7 font-normal text-gray-100">
              Restaurants and food services contribute significantly to this
              waste due to unsold inventory and surplus at the end of each day.
            </p>
            <div className="mt-3">
              <p className="mb-6 text-2xl font-anton lg:text-3xl">
                The economic toll of this waste:
              </p>
              <div>
                <span className="inline-block text-3xl text-blue-100 font-anton mr-1">
                  ₹92,000 crore
                </span>
                <span className="inline-block text-base font-bold text-gray-100">
                  Anually
                </span>
              </div>
            </div>
          </div>
          <img alt="hamburger amico" src="images/hamburger-amico.svg" />
        </div>
        <h4 className="mt-7 lg:mt-16 text-center relative block text-4xl text-blue-100 font-anton underline decoration-8 underline-offset-8 mb-5 lg:text-5xl">
          Few Facts 
        </h4>
        <ul className="grid grid-cols-1 gap-14 mt-7 lg:grid-cols-3 lg:gap-20 lg:mt-16">
          {wastedFoods.map((item, index) => {
            return (
              <li className="block" key={`item-${index}`}>
                <img
                  alt={item.title}
                  src={item.imageUrl}
                  className="max-h-80 min-h-80 h-full w-full object-cover"
                />
                <h3 className="mt-6 text-2xl leading-7 text-gray-100 font-anton">
                  {item.title}
                </h3>
              </li>
            );
          })}
        </ul>
      </section>
      <section className="bg-primary-200">
        <div className="container py-10 lg:pt-14 lg:pb-20">
          <h3 className="text-center relative block text-4xl text-white font-anton underline decoration-8 underline-offset-8 lg:text-5xl">
            Why use Surpeats
          </h3>
          <ul className="grid grid-cols-1 mt-14 lg:grid-cols-4 lg:gap-10 lg:mt-28">
            {useSurpeats.map((item, index) => {
              return (
                <li
                  key={`use-surpeats-${index}`}
                  className={`rounded-lg ${
                    "px-6 py-11 bg-white"
                  }`}
                >
                  <span className="block mb-4">{item?.icon}</span>
                  <span
                    className={`${
                      "text-2xl font-bold text-primary-200"
                    }`}
                  >
                    {item?.title}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </section>
      <section className="py-7 lg:py-40">
        <div className="container relative hidden xl:block">
          <h4 className="text-center relative block text-4xl text-blue-100 font-anton underline decoration-8 underline-offset-8 mb-5 lg:text-5xl">
            How to use the App
          </h4>
          <div className="absolute -left-5 top-52 flex flex-col max-w-80">
            <span className="bg-primary-200 size-20 p-5 rounded-lg">
              <BagIcon />
            </span>
            <h4 className="font-anton mt-4 mb-2 lg:text-2xl">Step 1</h4>
            <p className="text-base text-gray-200">
              Discover Mystery Bags available at stores and restaurants near
              you.
            </p>
          </div>
          <div className="absolute -left-5 bottom-52 flex flex-col max-w-80">
            <span className="bg-primary-200 size-20 p-5 rounded-lg">
              <WatchIcon />
            </span>
            <h4 className="font-anton mt-4 mb-2 lg:text-2xl">Step 3</h4>
            <p className="text-base text-gray-200">
              Head to the shop at the specified pickup time and collect the bag.
            </p>
          </div>
          <img src="images/how-to-use-surpeats.png" alt="How to use surpeats" />
          <div className="absolute -right-5 top-52 flex flex-col max-w-80">
            <span className="bg-primary-200 size-20 p-5 rounded-lg">
              <MobileIcon />
            </span>
            <h4 className="font-anton mt-4 mb-2 lg:text-2xl">Step 2</h4>
            <p className="text-base text-gray-200">
              Confirm your choice, reserve your food, and pay through the app.
            </p>
          </div>
          <div className="absolute -right-5 bottom-52 flex flex-col max-w-80">
            <span className="bg-primary-200 size-20 p-5 rounded-lg">
              <FruitIcon />
            </span>
            <h4 className="font-anton mt-4 mb-2 lg:text-2xl">Step 3</h4>
            <p className="text-base text-gray-200">
              Enjoy fresh meals while helping reduce food waste
            </p>
          </div>
        </div>
        <div className="container block relative xl:hidden">
          <h4 className="text-center relative block text-4xl text-blue-100 font-anton underline decoration-8 underline-offset-8 mb-5 lg:text-5xl">
            How to use the App
          </h4>
          <div>
            <img
              src="images/how-to-use-surpeats.png"
              alt="How to use surpeats"
            />
            <ul className="space-y-8 mt-10">
              {howToUseSteps.map((item, index) => {
                return (
                  <li className="flex flex-col" key={`howToUseSteps-${index}`}>
                    <span className="bg-primary-200 size-20 p-5 rounded-lg">
                      {item.icon}
                    </span>
                    <h4 className="font-anton mt-4 mb-2 lg:text-2xl">
                      {item.title}
                    </h4>
                    <p className="text-base text-gray-200">
                      {item.description}
                    </p>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </section>
      <Testimonials
        title="Internal Testimonials"
        description="Internal testimonials are feedback from those involved in Surpeats' prelaunch, providing valuable insights into their experiences and viewpoints. This feedback can be both positive and constructive, highlighting the strengths of Surpeats as well as areas for improvement."
        testimonials={testimonials}
      />
      <section className="py-16 lg:py-36">
        <div className="container">
          <div className="flex gap-8 flex-col lg:flex-row lg:items-center lg:gap-32">
            <div>
              <img
                src="images/lets-start-surpeats.png"
                alt="lets start surpeats"
              />
            </div>
            <div className="max-w-md w-full">
              <h3 className="text-4xl font-anton mb-8 text-blue-100 lg:mb-20 lg:text-5xl">
                Let's begin the drive toward ZERO FOOD WASTE. <br /> Become a
                #SURPEATSHERO
              </h3>
              <AppPlateFormLogos />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
